import { VIEW_ONLY_MODE } from '@domains/kyc';

// The KYC mode header lives in @domains/kyc so components there (e.g. UploadComponent) can attach
// it to their own requests; re-exported here for the app's API helpers.
export { KYC_MODE_HEADER, VIEW_ONLY_MODE, kycModeHeaders } from '@domains/kyc';

export const claimSessionURL = (
  sessionId: string,
  sessionAccess: string,
): string => `/v1/claim_session/${sessionId}/${sessionAccess}`;

export const getSessionInfo = (): {
  id: string;
  access: string;
  sessionFormType: string;
  sessionMode: string;
} => {
  let formType = '';
  let id = 'unknown';
  let access = 'unknown';
  let sessionMode = '';

  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);

    id = params.get('id') ?? id;
    access = params.get('access') ?? access;
    formType = params.get('formType') ?? formType;
    sessionMode = params.get('view_only') === 'true' ? VIEW_ONLY_MODE : '';
  }

  return { id, access, sessionFormType: formType, sessionMode };
};
